import React, {
    useContext,
    useState,
} from 'react';
import { useQuery, useMutation } from '@tanstack/react-query';

import { refetchBasketData, NotificationContext, handleError } from "../router"

import * as CONSTANTS from "../constants";
import * as QUERIES from "../query-functions";

import TicketTypeSelect from '../components/ticket-type-select'
import LoadingIndicator from '../components/loading-indicator';
import CrossIcon from "../svg/cross"

export default function BasketTicketItem (props) {

    const {notification, setNotification} = useContext(NotificationContext);

    const [inEditMode, setInEditMode] = useState(false);

    const { 
        isPending: isInstancePending,
        isFetching: isInstanceFetching,
        data: instanceData,
    } = useQuery({
        queryKey: ['instance', props.ticket.instance.id],
        queryFn: () => QUERIES.getInstance(props.ticket.instance.id),
        refetchOnWindowFocus: false,
        enabled: inEditMode,
        retry: false,
        staleTime: 86400000
    })
    
    const removeTicket = useMutation({
        mutationFn: () => QUERIES.removeTickets([props.ticket.id]),
        onError: (error) => {
            handleError(error.message, setNotification);
        },
        onSuccess: () => {
            refetchBasketData();
        },
    })

    return (
        <li className='basket-item__ticket-list--item'>
            <p className='basket-item__ticket-list--area'>{props.ticket.planName} {props.ticket.seatName}</p>

            {inEditMode ?
                isInstancePending ?
                    <LoadingIndicator />
                    :
                    <TicketTypeSelect ticket={props.ticket} pricelist={instanceData?.priceList?.prices} setInEditMode={setInEditMode} /> 
                :
                props.ticket.planName != props.ticket.ticketType.name &&
                    <p className='basket-item__ticket-list--type'>{props.ticket.ticketType.name}</p>
            }

            <p className='basket-item__ticket-list--price'>£{props.ticket.total.toFixed(2)}</p>
            
            <div className='basket-item__ticket-list--amend-ticket'>
            
                {!inEditMode &&
                    <button type="button" onClick={() => setInEditMode(true)} className='btn--edit'>
                        Edit
                    </button>
                }

                <button type="button" onClick={() => removeTicket.mutateAsync()} className='btn btn--remove'>
                    <span className='sr-text'>Remove ticket</span>
                    <CrossIcon />
                </button>
            </div>
        </li>
    )
}